import { initChartsRequests, initRequestsCounts } from '../../constants/common';
import {
  SET_MAIN_SEARCH_PARAMS,
  SET_IS_COUNTING,
  RESET_REQUESTS_DATA,
  SET_STATISTICS_DATA,
  SET_DASHBOARD_DATA,
  SET_DASHBOARD_FILTERED_REQUESTS,
  SET_DASHBOARD_ITEMS,
} from '../actions/actionTypes';

const initialState = {
  requestsCounts: initRequestsCounts,
  chartsRequests: initChartsRequests,
  filteredRequests: [],
  mainSearchParams: '',
  isCounting: false,
  dashboardData: {},
  filteredDashboardRequests: {},
  dashboardItems: {},
};

const mainStatisticsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_STATISTICS_DATA:
      return {
        ...state,
        filteredRequests: payload.filteredRequests,
        chartsRequests: payload.chartsRequests,
        requestsCounts: payload.requestsCounts,
      };
    case SET_MAIN_SEARCH_PARAMS:
      return {
        ...state,
        mainSearchParams: payload,
      };
    case SET_IS_COUNTING:
      return {
        ...state,
        isCounting: payload,
      };
    case RESET_REQUESTS_DATA:
      return {
        ...state,
        requestsCounts: initRequestsCounts,
        chartsRequests: initChartsRequests,
        filteredRequests: [],
        isCounting: false,
      };
    case SET_DASHBOARD_DATA:
      return {
        ...state,
        dashboardData: payload,
      };
    case SET_DASHBOARD_FILTERED_REQUESTS:
      return {
        ...state,
        filteredDashboardRequests: {
          ...state.filteredDashboardRequests,
          ...payload,
        },
      };
    case SET_DASHBOARD_ITEMS:
      return {
        ...state,
        dashboardItems: payload,
      };
    default:
      return state;
  }
};

export default mainStatisticsReducer;
